/**
 * Add-on sale badge + cutoff price for Easify "Chocolate Dragrees".
 * Keeps Easify modal/label markup intact so selection still works.
 */
(function () {
  var configEl = document.getElementById('bella-addon-sale-config');
  var config = { enabled: true, badgeText: '25% OFF', cutoffPrice: '90', moneyFormat: null };
  if (configEl) {
    try {
      config = Object.assign(config, JSON.parse(configEl.textContent || '{}'));
    } catch (e) {}
  }
  if (config.enabled === false) return;

  var BADGE_CLASS = 'bella-addon-sale-badge';
  var HOST_CLASS = 'bella-addon-sale-host';
  var CUTOFF_CLASS = 'bella-addon-cutoff-price';
  var MATCH = /chocolate\s*drag+r?ees/i;
  var IMAGE_HINT = /Bella_Fleur_Stories_1400_x_1700_px_5/i;
  var MONEY_RE = /(?:Dhs\.?|AED|DH)\s*[\d,]+(?:\.\d{1,2})?/i;
  var OPTION_IDS = {
    '4f7a3c4b-4f95-4540-98c1-11f9338bcbc5': true,
    '6950998': true,
    '6973235': true
  };

  function formatMoney(amount) {
    var n = Number(String(amount).replace(/,/g, ''));
    if (!isFinite(n)) return String(amount);
    var fixed = n.toFixed(2);
    var withComma = fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = config.moneyFormat || 'Dhs. {{amount}}';
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(n)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, withComma);
  }

  function isChocolateImage(img) {
    if (!img) return false;
    var src = img.currentSrc || img.src || img.getAttribute('src') || '';
    if (IMAGE_HINT.test(src)) return true;
    if (MATCH.test(img.alt || '')) return true;
    return false;
  }

  function isChocolateNode(node) {
    if (!node || node.nodeType !== 1) return false;

    var id =
      node.getAttribute('data-id') ||
      node.getAttribute('data-option-type-id') ||
      node.getAttribute('data-value') ||
      node.value ||
      '';
    if (id && OPTION_IDS[String(id)]) return true;

    var label = (node.getAttribute('aria-label') || node.title || '').trim();
    if (MATCH.test(label)) return true;

    if (node.matches && node.matches('img') && isChocolateImage(node)) return true;
    if (node.querySelector) {
      var imgs = node.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        if (isChocolateImage(imgs[i])) return true;
      }
    }

    return false;
  }

  function findSwatchHost(el) {
    return (
      el.closest(
        '.tpo-swatch-wrapper, .tpo_color-swatches-wrapper, .tpo_option-type-image-swatches-wrapper > label, .tpo_image-swatches-wrapper > label'
      ) || null
    );
  }

  function findTooltipImageHost(el) {
    // Prefer the black tooltip shell so the badge sits at the true top-left
    return (
      el.closest('.tpo_image-radio-tooltip, .tpo_image-checkbox-tooltip') ||
      el.closest(
        '.tpo_image-radio-tooltip_image-container, .tpo_image-checkbox-tooltip_image-container'
      ) ||
      null
    );
  }

  function addBadge(host, variant) {
    if (!host) return;
    host.classList.add(HOST_CLASS);
    if (variant === 'modal') host.classList.add('bella-addon-sale-host--modal');
    else host.classList.remove('bella-addon-sale-host--modal');

    var existing = host.querySelector(':scope > .' + BADGE_CLASS);
    var text = config.badgeText || '25% OFF';
    if (existing) {
      if (existing.textContent !== text) existing.textContent = text;
      return;
    }

    var badge = document.createElement('span');
    badge.className = BADGE_CLASS;
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = text;
    host.insertBefore(badge, host.firstChild);
  }

  function chocolateSelected() {
    var hosts = document.querySelectorAll('.' + HOST_CLASS + ':not(.bella-addon-sale-host--modal)');
    for (var i = 0; i < hosts.length; i++) {
      var h = hosts[i];
      if (
        h.classList.contains('selected') ||
        h.classList.contains('active') ||
        h.getAttribute('aria-checked') === 'true'
      ) {
        return true;
      }
      var input = h.querySelector('input.tpo_image-swatches-input, input.tpo_color-swatches-input, input[type="checkbox"], input[type="radio"]');
      if (input && input.checked) return true;
    }
    return false;
  }

  function enhanceAdditionalCharge() {
    if (!config.cutoffPrice && config.cutoffPrice !== 0) return;
    if (!chocolateSelected()) {
      document.querySelectorAll('.' + CUTOFF_CLASS + '[data-bella-addon-cutoff="1"]').forEach(function (n) {
        n.remove();
      });
      return;
    }

    var nodes = document.querySelectorAll('div, p, span, strong, b');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.querySelector('.' + CUTOFF_CLASS)) continue;
      if (el.children.length > 3) continue;

      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/additional charge/i.test(text)) continue;
      if (!MONEY_RE.test(text)) continue;

      // Prefer the element that directly wraps only the money amount
      var moneyEl = null;
      var childSpans = el.querySelectorAll('span, strong, b, em');
      for (var c = 0; c < childSpans.length; c++) {
        var ct = (childSpans[c].textContent || '').trim();
        if (MONEY_RE.test(ct) && ct.length < 40 && !childSpans[c].querySelector('.' + CUTOFF_CLASS)) {
          moneyEl = childSpans[c];
          break;
        }
      }

      var target = moneyEl || el;
      if (target.querySelector && target.querySelector('.' + CUTOFF_CLASS)) continue;

      var cutoff = document.createElement('span');
      cutoff.className = CUTOFF_CLASS;
      cutoff.setAttribute('data-bella-addon-cutoff', '1');
      cutoff.setAttribute('aria-hidden', 'true');
      cutoff.textContent = formatMoney(config.cutoffPrice);

      if (moneyEl) {
        moneyEl.parentNode.insertBefore(cutoff, moneyEl);
      } else {
        // Insert before the money text without rewriting the whole node
        var walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT, null);
        var textNode;
        while ((textNode = walker.nextNode())) {
          if (MONEY_RE.test(textNode.nodeValue || '')) {
            var match = (textNode.nodeValue || '').match(MONEY_RE);
            if (!match) continue;
            var idx = (textNode.nodeValue || '').indexOf(match[0]);
            var after = textNode.splitText(idx);
            after.splitText(match[0].length);
            after.parentNode.insertBefore(cutoff, after);
            break;
          }
        }
      }
      break;
    }
  }

  function scan() {
    // Swatch thumbnails only — never rewrite labels/inputs
    document
      .querySelectorAll(
        '.tpo_option-type-image-swatches-wrapper label, .tpo_image-swatches-wrapper label, .tpo-swatch-wrapper, .tpo_color-swatches-wrapper, img.tpo_image-swatch-img, img.tpo_radio-swatch-img, img.tpo_image-checkbox-img'
      )
      .forEach(function (el) {
        if (!isChocolateNode(el)) return;
        // Skip anything inside the hover modal content except image container handling below
        if (el.closest('.tpo_image-radio-tooltip, .tpo_image-checkbox-tooltip')) return;
        var host = findSwatchHost(el);
        if (host) addBadge(host, 'swatch');
      });

    // Modal/tooltip: badge on image container only — do not change modal text/UI
    document
      .querySelectorAll(
        '.tpo_image-radio-tooltip_image-container, .tpo_image-checkbox-tooltip_image-container, .tpo_image-radio-tooltip img, .tpo_image-checkbox-tooltip img'
      )
      .forEach(function (el) {
        if (!isChocolateNode(el)) return;
        var host = findTooltipImageHost(el);
        if (host) addBadge(host, 'modal');
      });

    enhanceAdditionalCharge();
  }

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scan();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleScan);
  } else {
    scheduleScan();
  }

  window.addEventListener('load', scheduleScan);
  document.addEventListener('change', scheduleScan, true);
  document.addEventListener('click', scheduleScan, true);
  setTimeout(scheduleScan, 500);
  setTimeout(scheduleScan, 1500);
  setTimeout(scheduleScan, 3000);

  try {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length) {
          scheduleScan();
          return;
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
